export default __webpack_public_path__ + "static/insfocus_small-1-4a9fb3a89fdef63fc2f76a75698a24f3.png";